export const CREATE_BET_HOUSE_QUERY = "create";

/** Opens the create-house modal on BondHouse. */
export const CREATE_BET_HOUSE_PATH = "/app/bethouse?create=1";

/** Legacy query param — still accepted by AppShell. */
export const LEGACY_CREATE_BET_HOUSE_QUERY = "newHouse";

export function getCreateBetHouseNav(isAuthenticated) {
  if (isAuthenticated) {
    return { to: CREATE_BET_HOUSE_PATH };
  }
  return {
    to: "/app/login",
    state: { from: CREATE_BET_HOUSE_PATH },
  };
}

export const withCreateBetHouseParam = (pathname = "/app/bethouse", search = "") => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.set(CREATE_BET_HOUSE_QUERY, "1");
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
};

export const MIN_HOUSE_ALLOCATION = 50000;
export const DEFAULT_MIN_BET = 500;
export const QUICK_ALLOCATION_AMOUNTS = [50000, 100000, 250000, 500000];

export const CREATE_STEPS = [
  { id: 1, title: "Name your house" },
  { id: 2, title: "Set your budget" },
  { id: 3, title: "Bet settings" },
  { id: 4, title: "Brand story" },
];

export const parseDigits = (value) => String(value || "").replace(/[^\d]/g, "");

export const validateHouseName = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "Enter a name for your bet house.";
  if (trimmed.length > 40) return "Name must be 40 characters or less.";
  return null;
};

export const validateAllocation = (amountRaw, userCash) => {
  const amount = Number(parseDigits(amountRaw));
  if (!Number.isFinite(amount) || amount <= 0) {
    return "Enter the Cash amount to allocate.";
  }
  if (amount < MIN_HOUSE_ALLOCATION) {
    return `Minimum allocation is ${MIN_HOUSE_ALLOCATION.toLocaleString()} Cash.`;
  }
  const cash = Number(userCash);
  if (Number.isFinite(cash) && amount > cash) {
    return `Insufficient Cash. You have ${cash.toLocaleString()} available.`;
  }
  return null;
};

export const validateBetSettings = ({ minSelections, minBet, maxBet }) => {
  const selections = parseInt(parseDigits(minSelections), 10);
  if (!Number.isFinite(selections) || selections < 1) {
    return "Enter a valid minimum number of selections (at least 1).";
  }

  const minBetValue = Number(parseDigits(minBet));
  if (!Number.isFinite(minBetValue) || minBetValue <= 0) {
    return "Enter a valid default minimum bet.";
  }

  const maxRaw = parseDigits(maxBet);
  if (maxRaw) {
    const maxBetValue = Number(maxRaw);
    if (!Number.isFinite(maxBetValue) || maxBetValue <= 0) {
      return "Default maximum bet must be a positive number.";
    }
    if (maxBetValue < minBetValue) {
      return "Default maximum bet must be at least the minimum bet.";
    }
  }

  return null;
};

export const buildCreateBetHousePayload = ({
  userId,
  name,
  amountAllocated,
  minSelections,
  minBet,
  maxBet,
  brandStory,
}) => {
  const selections = parseInt(parseDigits(minSelections), 10) || 2;
  const minBetValue = Number(parseDigits(minBet)) || DEFAULT_MIN_BET;
  const maxRaw = parseDigits(maxBet);
  const maxBetValue = maxRaw ? Number(maxRaw) : 0;

  return {
    name: String(name).trim(),
    amountAllocated: Number(parseDigits(amountAllocated)),
    userId,
    minSelectionsPerBet: selections,
    minFixture: selections,
    brandStory: String(brandStory || "").trim(),
    visibility: "public",
    tags: [],
    defaultMinBetAmount: minBetValue,
    defaultMaxBetAmount: maxBetValue > 0 ? maxBetValue : 0,
  };
};
